import React from 'react';
import style from './style.module.scss';
import {IHandlers, IProps} from './types';
import classNames from "classnames";

const NS = 'MaxOccupancyMessage';

export const NORMAL_TEXT = 'Maximum capacity reached for this section. Any further covers will be in breach of your max occupancy rules.';
export const TEXT_OVER_MULTIPLE_SECTION = 'This booking has reached its max occupancy in one of the selected sections. Note: this booking is across multiple sections and is now based on table max capacity to allow for multi-section bookings';

export default function MaxOccupancyMessage({isMultipleSection, isWide}: IProps & IHandlers) {

  const showTextBasedOnType = (isMultipleSection: boolean) => {
    return isMultipleSection ? TEXT_OVER_MULTIPLE_SECTION : NORMAL_TEXT;
  }

  return (
    <div className={style.root}>
      <div className={classNames({
        [style.wide]: isWide,
        [style.maxOccupancyMessage]: true
      })}>
        <div className={classNames({
          [style.overMax]: true
        })}>
          <p className={style.message} data-testid="max-occupancy-message">
            {showTextBasedOnType(isMultipleSection)}
          </p>
        </div>
      </div>
    </div>
  )
}

